import {
  alpha,
  styled,
  type Theme,
} from '@mui/material/styles';
import { icons } from 'assets/icons.js';

export const CheckboxIcon = styled('span')(({ theme }) => ({
  borderRadius: 3,
  width: 19,
  height: 19,
  border: `1px solid ${theme.palette.grey[600]}`,
  boxShadow: `0px 4px 12px ${alpha(theme.palette.common.black, 0.12)}`,
  backgroundColor: theme.palette.background.paper,
}));

type ColorFn = (theme: Theme) => string;

export const CheckboxCheckedIcon = styled(CheckboxIcon, {
  shouldForwardProp: prop => prop !== 'colorFn',
})<{
  colorFn: ColorFn;
}>(({ theme, colorFn }) => ({
  'backgroundColor': colorFn(theme),
  'border': '1px solid transparent',
  '&:before': {
    display: 'block',
    width: 17,
    height: 17,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundImage: `url(${icons.checkSvg})`,
    boxShadow: `0px 4px 12px ${alpha(theme.palette.common.black, 0.12)}`,
    content: '""',
  },
}));

export const CheckboxIndeterminateIcon = styled(CheckboxIcon, {
  shouldForwardProp: prop => prop !== 'colorFn',
})<{
  colorFn: ColorFn;
}>(({ theme, colorFn }) => ({
  'backgroundColor': colorFn(theme),
  'border': '1px solid transparent',
  '&:before': {
    display: 'block',
    width: 17,
    height: 17,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundImage: `url(${icons.minusSvg})`,
    boxShadow: `0px 4px 12px ${alpha(theme.palette.common.black, 0.12)}`,
    content: '""',
  },
}));

export const checkboxStyles = {
  'padding': 0,
  '&:hover': { bgcolor: 'transparent' },
};
